import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import AffiliateCard from "./AffiliateCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Affiliates() {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/affiliates`)
      .then((r) => setItems(r.data.filter((a) => a.mis_en_avant).slice(0, 4)))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section id="ressources" data-testid="affiliates-band" className="py-24 bg-[#0D0D10] border-y border-[#27272A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-wrap items-end justify-between gap-6 mb-12"
        >
          <div>
            <p className="text-[#C5A059] text-xs uppercase tracking-[0.4em] mb-6">{t("aff.eyebrow")}</p>
            <h2 className="font-display text-4xl lg:text-5xl uppercase font-bold leading-[0.95]">
              {t("aff.title.a")} <span className="text-[#C5A059]">{t("aff.title.b")}</span>
            </h2>
            <p className="text-sm text-[#A1A1AA] mt-4 max-w-xl">{t("aff.text")}</p>
          </div>
          <a
            href="/ressources"
            data-testid="affiliates-view-all"
            className="flex items-center gap-2 border border-[#C5A059] text-[#C5A059] px-6 py-3 text-[11px] uppercase tracking-[0.2em] hover:bg-[#C5A059] hover:text-black transition-colors duration-300"
          >
            {t("aff.all")} <ArrowRight size={13} />
          </a>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((a, i) => (
            <motion.div
              key={a.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <AffiliateCard aff={a} />
            </motion.div>
          ))}
        </div>

        <p className="text-[10px] text-[#52525B] mt-8 leading-relaxed" data-testid="affiliates-disclosure">
          {t("aff.disclosure")}
        </p>
      </div>
    </section>
  );
}
